import Vue from 'vue'
import Router from 'vue-router'
import p01_login from '@/pages/p01_login'
import p02_hi from '@/pages/p02_hi'

Vue.use(Router)
export default new Router({
  routes: [
    {
      path: '/',
      name: 'index',
      component: p01_login
    },
    {
      path: '/p02_hi',
      name: 'p02_hi',
      component: p02_hi, //  PgMg, //  // 首页，手机用Hi,电脑Mg
      meta: {
        allowBack: false,
        keepAlive: true
      }
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js